module.exports = __webpack_public_path__ + "img/logo.1eec09da.png";